module.exports = __webpack_public_path__ + "img/pipe1.be939ad3.png";